<script lang="ts">
  import { onMount, untrack, type Snippet } from "svelte"
  import CTA from "@kontextwerk/web-sdk/ui/actions/CTA.svelte"
  import ActionBox from "@kontextwerk/web-sdk/ui/layout/ActionBox.svelte"
  import PostalRecipientForm, {
    postalRecipientValidation,
    type PostalRecipientFormValue,
  } from "../../../postal-recipient-form"
  let {
    initialValue,
    manual,
    onApply,
    onremoveOverlay,
    onshowOverlay,
    setActionButtonSnippet,
  }: {
    initialValue: PostalRecipientFormValue
    manual: boolean
    onApply: (value: PostalRecipientFormValue) => string | null
    onremoveOverlay?: () => void
    onshowOverlay?: () => void
    setActionButtonSnippet?: (snippet: Snippet | null) => void
  } = $props()
  let value = $state(untrack(() => ({ ...initialValue })))
  let error = $state<string | null>(null)
  const apply = () => {
    error = postalRecipientValidation(value)

    if (error) return

    error = onApply({ ...value })

    if (!error) onremoveOverlay?.()
  }
  onMount(() => {
    setActionButtonSnippet?.(actions)
    onshowOverlay?.()

    return () => setActionButtonSnippet?.(null)
  })
</script>

<div class="postal-recipient-editor">
  <p class="hint">
    {manual
      ? "Mit der Gesamtbestätigung werden dieser Ansprechpartner und seine Postadresse gespeichert."
      : "Eine Namensänderung benennt bei der Gesamtbestätigung auch den gespeicherten Ansprechpartner um. Für eine andere Adresse wählen Sie „Individuell erfassen“."}
    „Übernehmen“ ändert nur diese Planungszeile. Gespeichert wird erst mit „Ankündigungspläne anlegen“.
  </p>
  <ActionBox>
    <PostalRecipientForm bind:value {manual} showHint={false} />
  </ActionBox>
  {#if error}<p class="validation-message" role="alert">{error}</p>{/if}
</div>
{#snippet actions()}
  <CTA
    type="secondaryButton"
    content="Abbrechen"
    darkMode={false}
    onclick={() => onremoveOverlay?.()}
  />
  <CTA type="primaryButton" content="Übernehmen" darkMode={false} onclick={apply} />
{/snippet}

<style>
  .postal-recipient-editor {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .hint {
    margin: 0;
    color: color-mix(in srgb, var(--text-invers-100) 72%, transparent);
    line-height: 1.4;
  }

  .validation-message {
    margin: 0;
    color: var(--error-100, #b42318);
  }
</style>
